import get from 'lodash/get.js';
import has from 'lodash/has.js';

export default {
    data: () => ({
        now: null,
        isLateIntervalId: null,
    }),

    created() {
        this.now = this.$moment.utc();

        this.isLateIntervalId = setInterval(() => (this.now = this.$moment.utc()), 1000);
    },

    beforeUnmount() {
        clearInterval(this.isLateIntervalId);
    },

    computed: {
        isLate() {
            if (!this.now) return false;

            return this.$store.getters[`${this.namespace}/${this.uuid}/isLate`](this.now);
        },

        canSubmitLate() {
            if (!this.settings && !this.activity?.activity_settings) {
                throw new Error('Computed property "settings" must be defined.');
            }

            if (has(this.activity, 'activity_settings.allow_submissions_after_due_date')) {
                return get(this.activity, 'activity_settings.allow_submissions_after_due_date');
            }

            return this.get(this.settings).allow_submissions_after_due_date;
        },

        completed() {
            return this.get('completed') !== null;
        },
    },

    methods: {
        get(field) {
            if (!this.uuid) return;

            return this.$store.getters[`${this.namespace}/${this.uuid}/get`](field);
        },
    },
};
